module.exports = __webpack_public_path__ + "img/MDCCPTA.0a52f317.jpeg";